"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSignatureKey = void 0;
const repository_1 = require("../../../security/authoriser/infra/repositories/verifySignatureKey/repository");
class MbSignatureKey {
    constructor(api, data) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
    }
    async doVerify(value) {
        const verificationData = {
            signatureKey: value,
            signatureKeyPositions: this.data.signatureKeyPositions,
        };
        return repository_1.verifySignatureKeyChallengeRepository.verify(this.api, this.progressId, verificationData);
    }
}
exports.MbSignatureKey = MbSignatureKey;
//# sourceMappingURL=signatureKey.js.map